import { defineStore } from "pinia";
import { ref, computed } from "vue";

export type TPendingTerm = {
  id: string;
  title: string;
  version: number;
};

export const usePendingTermsStore = defineStore("pendingTerms", () => {
  const pendingTerms = ref<TPendingTerm[]>([]);

  const isBlocked = computed(() => pendingTerms.value.length > 0);

  const triggerBlock = (terms: TPendingTerm[]) => {
    pendingTerms.value = terms;
  };

  const clearBlock = () => {
    pendingTerms.value = [];
  };

  return { pendingTerms, isBlocked, triggerBlock, clearBlock };
});
